/* eslint-disable react/forbid-prop-types */
import React, { PropTypes } from 'react';
import { themer } from '@spp/theme-provider';

const VgGoldCompetition = ({ codes, theme }) => {
    const date = new Date();
    const key = `${date.getDate()}/${date.getMonth() + 1}`;
    const promocode = codes[key];
    if (!promocode) {
        return null;
    }
    return (
        <div className={theme.root} rel="noindex">
            <h4>Vinn Gull i VG+</h4>
            <p className={theme.promoCode}>
                Dagens kode: <strong>{promocode}</strong>
            </p>
            <p className={theme.instructions}>
                Send SMS med koden til 2424. Tjenesten koster 1 kr.
            </p>
            <p className={theme.disclaimer}>
                Ved å delta i konkurransen samtykker du til at vi kan kontakte deg på SMS med
                relevant informasjon om konkurransen «Finn Gull i VG».{' '}
                <a href="https://gull.vg.no">Les mer om konkurransen her »</a>
            </p>
        </div>
    );
};

VgGoldCompetition.propTypes = {
    codes: PropTypes.any.isRequired,
    theme: PropTypes.shape({
        root: PropTypes.string,
        url: PropTypes.string,
    }).isRequired,
};

export default themer('@vg/gold-competition')(VgGoldCompetition);



/** WEBPACK FOOTER **
 ** ./src/local-components/article/VgGoldCompetition.js
 **/